import { render, staticRenderFns } from "./UpdateSupportEnviroment.vue?vue&type=template&id=4b582ba2&scoped=true&"
import script from "./UpdateSupportEnviroment.vue?vue&type=script&lang=js&"
export * from "./UpdateSupportEnviroment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b582ba2",
  null
  
)

export default component.exports